import GetCookieByName from "../hooks/GetCookie";
import http from "./httpservices";
const PAYMENT_PORTAL_BASEURL = process.env.REACT_APP_PAYMENT_PORTAL_BASE_URL;
const FINANCIAL_YEAR = 'All';

async function verifyProfileLinkForPayment(postdata) {
    const REQUEST_HEADERS = {
        "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"],
        "x-fy": FINANCIAL_YEAR
    };

    const resp = http.post(
        PAYMENT_PORTAL_BASEURL + `socialmedia/influencer/payment/details`,
        postdata,
        {
            headers: REQUEST_HEADERS
        }
    );

    return resp;
}

async function generatePaymentLinkForCreator(postdata) {
    const REQUEST_HEADERS = {
        "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"],
        "x-fy": FINANCIAL_YEAR
    };

    const resp = http.post(
        PAYMENT_PORTAL_BASEURL + 'payment/generate-payment-link-creator',
        postdata,
        {
            headers: REQUEST_HEADERS
        }
    );

    return resp;
}

async function createPaymentQueue(postdata) {
    const REQUEST_HEADERS = {
        "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"],
        "x-fy": FINANCIAL_YEAR
    };

    const { data } = await http.post(
        PAYMENT_PORTAL_BASEURL + 'payment/bulk-generate/preview',
        postdata,
        {
            headers: REQUEST_HEADERS
        }
    );

    return data;
}

async function fetchPaymentQueueLinks(campaignId) {
    const REQUEST_HEADERS = {
        "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"],
        "x-fy": FINANCIAL_YEAR
    };

    const { data } = await http.get(
        PAYMENT_PORTAL_BASEURL + `payment/bulk-generate/preview/${campaignId}`,
        {
            headers: REQUEST_HEADERS
        }
    );

    return data;
}

async function updatePaymentQueuePricing(queueId, postdata) {
    try {
        const { data } = await http.patch(
            PAYMENT_PORTAL_BASEURL + `payment/bulk-generate/pricing/${queueId}`,
            postdata,
            {
                headers: {
                    "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"],
                    "x-fy": FINANCIAL_YEAR
                }
            }
        )
        return data;
    }
    catch (error) {
        return error?.response?.data || {
            success: false,
            message: error?.message
        }
    }
}

async function unlockOrDeletePaymentQueue(action, queueId) {
    const REQUEST_HEADERS = {
        "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"],
        "x-fy": FINANCIAL_YEAR
    };

    if (action === "unlock_queue") {
        const { data } = await http.patch(
            PAYMENT_PORTAL_BASEURL + `payment/bulk-generate/unlock/${queueId}`,
            { headers: REQUEST_HEADERS }
        );

        return data;
    }

    if (action === "delete") {
        const { data } = await http.delete(
            PAYMENT_PORTAL_BASEURL + `payment/bulk-generate/queue/${queueId}`,
            { headers: REQUEST_HEADERS }
        );

        return data;
    }

    return;
}

async function assignPaymentQueueToVendor(postdata) {
    const { data } = await http.post(
        PAYMENT_PORTAL_BASEURL + `payment/bulk-generate/assign-vendor`,
        postdata,
        {
            headers: {
                "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"],
                "x-fy": FINANCIAL_YEAR
            }
        }
    )

    return data;
}

async function fetchQueueStatus(postdata, campaignId) {
    const { data } = await http.post(
        PAYMENT_PORTAL_BASEURL + `payment/bulk-generate/queue/status/${campaignId}`,
        postdata,
        {
            headers: {
                "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"],
                "x-fy": FINANCIAL_YEAR
            }
        }
    )

    return data;
}

async function generatePaymentLinks(postdata) {
    const { data } = await http.post(
        PAYMENT_PORTAL_BASEURL + `payment/bulk-generate/create-payment-links`,
        postdata,
        {
            headers: {
                "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"],
                "x-fy": FINANCIAL_YEAR
            }
        }
    )

    return data;
}

async function createCombinedLinkForCreator(postdata) {
    const { data } = await http.post(
        PAYMENT_PORTAL_BASEURL + `link/club/common-payment-link`,
        postdata,
        {
            headers: {
                "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"],
                "x-fy": FINANCIAL_YEAR
            }
        }
    );

    return data;
}

async function createFollowUpPaymentQueue(queueId) {
    const { data } = await http.post(
        PAYMENT_PORTAL_BASEURL + `payment/bulk-generate/follow-up/${queueId}`,
        {
            headers: {
                "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"],
                "x-fy": FINANCIAL_YEAR
            }
        }
    )

    return data;
}

async function createAdvanceQueue(postdata) {
    const { data } = await http.post(
        PAYMENT_PORTAL_BASEURL + `payment/bulk-generate/advance-payment`,
        postdata,
        {
            headers: {
                "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"],
                "x-fy": FINANCIAL_YEAR
            }
        }
    )

    return data;
}

async function getCampaignDetails(postdata) {
    const { data } = await http.post(
        PAYMENT_PORTAL_BASEURL + `campaign/id`,
        postdata,
        {
            headers: {
                "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"],
                "x-fy": FINANCIAL_YEAR
            }
        }
    );

    return data;
}

async function getInfluencerDetails(id) {
    const { data } = await http.get(
        PAYMENT_PORTAL_BASEURL + `influencer/profile/detail/${id}`,
        {
            headers: {
                "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"],
                "x-fy": FINANCIAL_YEAR
            }
        }
    );

    return data;
}

async function getVendorDetails(postdata) {
    const { data } = await http.post(
        PAYMENT_PORTAL_BASEURL + `company/id`,
        postdata,
        {
            headers: {
                "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"],
                "x-fy": FINANCIAL_YEAR
            }
        }
    )

    return data;
}

async function getProfileDetails(postdata) {
    const { data } = await http.post(
        PAYMENT_PORTAL_BASEURL + `payment/detail/status`,
        postdata,
        {
            headers: {
                "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"],
                "x-fy": FINANCIAL_YEAR
            }
        }
    )

    return data;
}

async function getProfileOverview(postdata) {
    const { data } = await http.post(
        PAYMENT_PORTAL_BASEURL + `payment/overview`,
        postdata,
        {
            headers: {
                "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"],
                "x-fy": FINANCIAL_YEAR
            }
        }
    );

    return data;
}

async function createClubLink(postdata) {
    const { data } = await http.post(
        PAYMENT_PORTAL_BASEURL + `link/club`,
        postdata,
        {
            headers: {
                "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"],
                "x-fy": FINANCIAL_YEAR
            }
        }
    );

    return data;
}

async function fetchBankDetails(id, isVendor = true) {
    // add filter later on basis of isVendor
    const { data } = await http.post(
        PAYMENT_PORTAL_BASEURL + `bankdetails/companydetails`,
        { id: id },
        {
            headers: {
                "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"],
                "x-fy": FINANCIAL_YEAR
            }
        }
    );

    return data;
}

async function generateExpenseLink(postdata) {
    const { data } = await http.post(
        PAYMENT_PORTAL_BASEURL + `payment/expenselink/`,
        postdata,
        {
            headers: {
                "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"],
                "x-fy": FINANCIAL_YEAR
            }
        }
    );

    return data;
}

async function uploadFile(formdata, uploadtype) {
    let endpoint = '';

    if (uploadtype === "invoice") {
        endpoint = PAYMENT_PORTAL_BASEURL + `payment/upload`;
    }

    if (uploadtype === "screenshot") {
        endpoint = PAYMENT_PORTAL_BASEURL + `payment/uploadscreenshot`;
    }

    if (uploadtype === "paygst") {
        endpoint = PAYMENT_PORTAL_BASEURL + `payment/uploadgst`;
    }

    if (!endpoint) {
        return {
            success: false
        }
    };

    const { data } = await http.post(
        endpoint,
        formdata,
        {
            headers: {
                "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"],
                "x-fy": FINANCIAL_YEAR
            }
        }
    );

    console.log(`in upload file data: `, data);
    return data;
}
async function updatePayableDate(queueId, data) {
    const { data: response } = await http.patch(
        PAYMENT_PORTAL_BASEURL + `payment/bulk-generate/update-payable-date/${queueId}`,
        data,
        {
            headers: {
                "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"],
                "x-fy": FINANCIAL_YEAR
            }
        }
    );
    return response;
}
export default {
    verifyProfileLinkForPayment,
    generatePaymentLinkForCreator,
    createPaymentQueue,
    fetchPaymentQueueLinks,
    updatePaymentQueuePricing,
    unlockOrDeletePaymentQueue,
    assignPaymentQueueToVendor,
    fetchQueueStatus,
    generatePaymentLinks,
    createCombinedLinkForCreator,
    createFollowUpPaymentQueue,
    createAdvanceQueue,
    getCampaignDetails,
    getInfluencerDetails,
    getVendorDetails,
    getProfileDetails,
    getProfileOverview,
    createClubLink,
    fetchBankDetails,
    generateExpenseLink,
    uploadFile,
    updatePayableDate
};